// extracted by mini-css-extract-plugin
export default {"container":"NoiDoi_container__TNyMi","contentWrapper":"NoiDoi_contentWrapper__f4cVE","block":"NoiDoi_block__ORyQM","blockImage":"NoiDoi_blockImage__5mzR1"};